import styled from "@emotion/styled"
import { faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { Box, Button, Dialog, DialogTitle, Grid, IconButton, TextField, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import theme from "css/theme/light"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export const SearchUserDialog: React.FC<any> = (props) => {
  const { open, onClose } = props
  const handleClose = () => {
    onClose(null)
  }
  const [searchResult, searchApi] = useApi() as [IApiResult, IApiFunc]
  const [searchParam, setSearchParam] = useState<string | null>(null)
  const [noSearchFound, setNoSearchFound] = useState<boolean>(false)
  const [result, setResult] = useState<any[]>([])
  const { t } = useTranslation()

  const searchUser = () => {
    if (searchParam !== null && searchParam !== "") {
      searchApi.get(apiEndpoints.systemadmincustomers.getuserbysearch.replace("{searchparam}", searchParam))
    } else {
      setResult([])
    }
  }

  useEffect(() => {
    if (searchResult.status === 2) {
      setResult(searchResult.data)
      if (searchParam !== null && searchResult.data.length < 1) {
        setNoSearchFound(true)
      }
    }
  }, [searchResult])

  const StyledTypography = styled(Typography)(({ theme }) => ({
    wordWrap: "break-word",
  }))

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="lg"
      PaperProps={{
        style: { height: "100vh", width: "100%" }
      }}>
      <DialogTitle style={{ height: "100%" }}>
        <Grid
          container
          justifyContent="space-between"
          sx={{
            alignItems: {
              xs: 'end',
              sm: 'center',
            },
            flexDirection: {
              xs: 'column-reverse',
              sm: 'row',
            },
          }}
          marginBottom={2}>
          <Grid item>
            <Typography variant="h1">{t("settings.customer.search_after_user", "Search for users in the Transport Portal")}</Typography>
          </Grid>
          <Grid item>
            <IconButton aria-label="close" onClick={() => handleClose()} size="large">
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container flexDirection="row" alignItems="center" spacing={3} marginBottom={3}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label={t("global.search_for_user_name_email", "Search users by name, username or email")}
              name="user"
              fullWidth
              onChange={
                (e) => {
                  setSearchParam(e.target.value)
                  setNoSearchFound(false)
                }
              }
            />
          </Grid>
          <Grid xs={12} item>
            <Button variant="contained" color="primary" onClick={searchUser}>
              {t("settings.customer.search_user", "Search user")}
            </Button>
          </Grid>
          <Grid item>
            {noSearchFound && (
              <Typography variant="h5" color="primary">
                {t("global.no_result_for_search", "global.no_result_for_search")} "{searchParam}"
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container flexDirection="row" alignItems="center" spacing={2}>
          {searchResult.status === 2 &&
            result.map((user: any) => (
              <Grid item xs={12}>
                <Box padding={2} border={1} borderRadius={8} borderColor={(theme.palette as any).default.light}>
                  <Grid
                    container
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Grid item md={2} xs={12}>
                      <Typography variant="bodySmall" color="textSecondary">
                        {t("global.name", "Name")}
                      </Typography>
                      <StyledTypography variant="bodySmall" fontWeight="600">
                        {user.name}
                      </StyledTypography>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Typography variant="bodySmall" color="textSecondary">
                        {t("global.customer", "Customer")}
                      </Typography>
                      <StyledTypography variant="bodySmall">{user.customerName}</StyledTypography>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <Typography variant="bodySmall" color="textSecondary">
                        {t("global.email", "Email")}
                      </Typography>
                      <StyledTypography variant="bodySmall"> {user.email ? user.email : "Ej angivet"}</StyledTypography>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <Typography variant="bodySmall" color="textSecondary">
                        {t("global.username", "Username")}
                      </Typography>
                      <StyledTypography variant="bodySmall"> {user.username}</StyledTypography>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        component={Link}
                        variant="text"
                        to={allRoutes.SystemadminCustomersEditUsersEdit(user.customerId, user.id)}
                        endIcon={<OpenInNewIcon style={{ color: (theme.palette as any).primary[800] }} />}>
                        <Typography variant="labelSmallBold" color="textPrimary">
                          {t("global_go_to_user", "Go to user")}
                        </Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ))}
        </Grid>
      </DialogTitle>
    </Dialog>
  )
}
